import styled from 'styled-components';

export const ReasoningTextStyle = styled.div`
  padding: 16px 8px;
  border-radius: 18px;
  word-wrap: break-word;
  color: ${(props) => props.theme.colors.gray600};
  line-height: 1.5;
  font-size: 14px;

  ol,
  ul {
    padding-left: 0;
    margin: 0;
    margin-bottom: 1em;
  }

  ol,
  ul {
    margin-top: 1em;
    margin-bottom: 0;
  }

  ol ol {
    margin-top: 0;
  }

  ul ul {
    margin-top: 0;
  }

  ul {
    list-style: none;

    li::before {
      font-size: 24px;
      display: inline-block;

      content: '•';
      padding-left: 2px;
      margin-right: 8px;
      margin-left: -20px;
      flex-shrink: 0;
    }
  }
  ol {
    list-style: decimal;
    margin-left: 2px;
  }
  li {
    padding-left: 12px;
    margin-bottom: 0.5rem;
  }

  li:last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3 {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    font-weight: 600;
    color: ${(props) => props.theme.colors.gray950};
  }

  h1 {
    font-size: 1.5em;
  }

  h2 {
    font-size: 1.25em;
  }

  h3 {
    font-size: 1.1em;
  }

  strong {
    display: inline-block;
    margin-bottom: 2px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.gray600};
  }

  code {
    font-size: 12px;
    color: ${(props) => props.theme.colors.gray600};
    background-color: ${(props) => props.theme.colors.gray150};
    padding: 0px 2px;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray300};
  }

  strong:has(+ br):first-child {
    margin-top: 0;
  }

  strong:has(+ br) {
    margin-top: 16px;
  }
`;
